import { Badge } from "../ui/badge";

const TONE = {
  danger: "bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-300",
  warning: "bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300",
  info: "bg-sky-100 text-sky-800 dark:bg-sky-950/40 dark:text-sky-300",
  success: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300",
  muted: "bg-muted text-muted-foreground",
};

/* Tenant health chip + one-line detail (payment failed / trial lapsed / on trial / live …). */
export function HealthBadge({ health, testId, withDetail = true }) {
  if (!health) return null;
  return (
    <span className="inline-flex flex-col items-start gap-0.5" data-testid={testId}>
      <Badge className={`text-[10px] ${TONE[health.tone] || TONE.muted}`} data-testid={testId ? `${testId}-label` : undefined}>{health.label}</Badge>
      {withDetail && health.detail && <span className="text-[10px] text-muted-foreground">{health.detail}</span>}
    </span>
  );
}

export const HEALTH_ORDER = ["payment_failed", "trial_lapsed", "trialing", "live", "inactive", "canceled"];
export const HEALTH_LABELS = { payment_failed: "Payment failed", trial_lapsed: "Trial lapsed", trialing: "On trial", live: "Live", inactive: "Not subscribed", canceled: "Cancelled" };

/* Small count strip — "1 payment failed · 2 on trial · 5 live". */
export function HealthCounts({ counts = {}, testId }) {
  const parts = HEALTH_ORDER.filter((k) => counts[k]).map((k) => `${counts[k]} ${HEALTH_LABELS[k].toLowerCase()}`);
  if (!parts.length) return null;
  return <p className="text-[11px] text-muted-foreground" data-testid={testId}>{parts.join(" · ")}</p>;
}
